import { useState } from "react";
import API from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

// Shown under any AI output: disclosure label + "Report this result".
export const AIResultNote = ({ feature, refId = "", text = "" }) => {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const send = async () => {
    try {
      await API.post("/ai/report", { feature, ref_id: refId, text: String(text || "").slice(0, 4000), reason });
      toast.success("Thanks. We'll review this result.");
      setOpen(false); setReason("");
    } catch { toast.error("Could not send report"); }
  };
  return (
    <div className="flex items-center justify-between gap-2 text-[10px] text-zinc-500" data-testid={`ai-result-note-${feature}`}>
      <span>AI-generated — review before sharing.</span>
      <button type="button" onClick={() => setOpen(true)} className="underline hover:text-zinc-800"
              data-testid={`ai-report-result-${feature}`}>Report this result</button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-sm" data-testid="ai-report-dialog">
          <DialogHeader>
            <DialogTitle>Report this result</DialogTitle>
            <DialogDescription>Tell us what's wrong with this AI result (optional).</DialogDescription>
          </DialogHeader>
          <Textarea value={reason} onChange={(e) => setReason(e.target.value)} maxLength={500} data-testid="ai-report-reason" />
          <Button onClick={send} className="w-full" data-testid="ai-report-submit">Send report</Button>
        </DialogContent>
      </Dialog>
    </div>
  );
};
